import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconJump: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconJump"><Path d="M7 19.5L17 19.5" stroke="currentColor"/><Path d="M15 4.5H21.5V11" stroke="currentColor"/><Path d="M21 5C16.2353 9.2963 12.5294 13.5926 12 19.5" stroke="currentColor"/><Path d="M1 6.5C6.5 6.5 12 12.5 12 19.405V19.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconJump;
